import { render, staticRenderFns } from "./CrowdfundingTab.vue?vue&type=template&id=789ea63d&"
import script from "./CrowdfundingTab.vue?vue&type=script&lang=js&"
export * from "./CrowdfundingTab.vue?vue&type=script&lang=js&"
import style0 from "./CrowdfundingTab.vue?vue&type=style&index=0&id=789ea63d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports